import { isUSRegionSelector, useRegionStore } from '@packages/stores';

import { Assets } from '@assets';
import { Button } from '@elements/button';
import { Text } from '@elements/text';
import { i18n } from '@i18n';
import { useTripStore } from '@store';
import { testProps } from '@utils';

const NUMBER_OF_STARS = i18n.t('confirmation.leaveAReview.numberOfStars');
const stars = Array.from({ length: NUMBER_OF_STARS });

export const LeaveAReview = () => {
  const hasPolicyBeenIssued = useTripStore(state => !!state.trip?.policy?.policyNumber);
  const isUS = useRegionStore(isUSRegionSelector);

  if (!hasPolicyBeenIssued) {
    return null;
  }

  const link = isUS
    ? 'https://www.trustpilot.com/evaluate/freely.me'
    : 'https://www.productreview.com.au/listings/freely/write-review';

  return (
    <div className="flex flex-col rounded-2xl p-s16 gap-s16 bg-santorini-100">
      <Text {...testProps('confirmation-leave-a-review-title')} variant="subTitle-20/sb">
        {i18n.t('confirmation.leaveAReview.title')}
      </Text>
      <div className="flex flex-row gap-s4">
        {stars.map((it, index) => (
          <Assets.BlackStar key={index} />
        ))}
      </div>
      <Text {...testProps('confirmation-leave-a-review-description')} variant="body-16/r">
        {i18n.t('confirmation.leaveAReview.description')}
      </Text>
      <a href={link} target={'_blank'} rel="noreferrer" className="no-underline">
        <Button
          {...testProps('confirmation-leave-a-review-button')}
          variant="secondary"
          title={i18n.t('confirmation.leaveAReview.buttonText')}
          className="w-[14rem]"
        />
      </a>
    </div>
  );
};
